<template>
  <div id="introduce">
    <p>你想品尝与众不同的味道吗？</p>
    <p>海底捞私人定制服务，</p>
    <p>甄选金牌调味师，</p>
    <p>为你量身定制专属味道。</p>
    <div class="serve-place">
      <img src="../images/shop.png"/>
      &nbsp;
      <span>可提供服务的门店：北京世界城店</span>
    </div>
    <div class="introduce-logo"></div>
  </div>
</template>
<script>
  export default {
    name: "introduce"
  }
</script>
<style lang="stylus" scoped>
  @import '../../../assets/css/func.styl'
  #introduce
    padding-top 1.34rem
    text-align: center
    font-size: .36rem
    color: rgb(63, 63, 63)
    background: #fff
    p
      margin-bottom: .66rem
    .serve-place
      display flex
      align-items center
      justify-content center
      margin: .38rem 0 2.23rem 0
      font-size: .24rem
      img
        width: .3rem
        height: .3rem
    .introduce-logo
      width: 4.93rem
      height: .86rem
      margin: 0 auto
      bg('../images/logo_yqhh')
</style>


// WEBPACK FOOTER //
// src/components/share/share/introduce.vue